module.exports = __webpack_public_path__ + "img/iosStep-2.a07a7804.webp";